// Registers the custom service worker and activates new builds immediately.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d?\d)){3}$/)
);

let refreshing = false;

function onControllerChange() {
  if (refreshing) {
    return;
  }
  refreshing = true;
  window.location.reload();
}

function listenForWaitingWorker(registration) {
  const waitingWorker = registration.waiting;
  if (!waitingWorker) {
    return;
  }

  if (navigator.serviceWorker.controller) {
    waitingWorker.postMessage({ type: 'SKIP_WAITING' });
  }
}

function trackInstallingWorker(registration) {
  registration.addEventListener('updatefound', () => {
    const installingWorker = registration.installing;
    if (!installingWorker) {
      return;
    }

    installingWorker.addEventListener('statechange', () => {
      if (installingWorker.state === 'installed') {
        listenForWaitingWorker(registration);
      }
    });
  });
}

function registerValidSW(swUrl) {
  navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);

  navigator.serviceWorker
    .register(swUrl, { updateViaCache: 'none' })
    .then((registration) => {
      trackInstallingWorker(registration);
      listenForWaitingWorker(registration);

      registration.update();

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          registration.update();
        }
      });

      window.setInterval(() => {
        registration.update();
      }, 60 * 60 * 1000);
    })
    .catch(() => {
      // Service worker registration failed — app still works without offline support.
    });
}

export function register() {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  if (!('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);

    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    registerValidSW(swUrl);
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
